import styled from 'styled-components';

export const QuickQuoteCircle = styled.div`
  height: 275px;
  width: 275px;
  text-align: center;
  background: rgb(244, 245, 246);
  border-radius: 50%;
  position: relative;
  vertical-align: middle;
  z-index: 1;
`;
